"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCustomJS = getCustomJS;
exports.deleteCustomJS = deleteCustomJS;
exports.addCustomJS = addCustomJS;
exports.updateCustomJS = updateCustomJS;
exports.validateCustomJS = validateCustomJS;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _params = require("hub-http/helpers/params");

var BASE_URL = 'reports/v1/javascript';

function getCustomJS() {
  return _apiClient.default.get(BASE_URL, {
    query: {
      timestamp: Date.now()
    }
  }).then(function (res) {
    return res.map(function (script) {
      return (0, _extends2.default)({}, script, {
        name: script.name || ''
      });
    }).reverse();
  });
}

function deleteCustomJS(id) {
  return _apiClient.default.delete(BASE_URL + "/" + id);
}

function createPayload(name, jsData) {
  return {
    data: (0, _params.stringify)({
      content: jsData,
      name: name
    }),
    headers: {
      'content-type': 'application/x-www-form-urlencoded'
    }
  };
}

function addCustomJS(name, jsData) {
  return _apiClient.default.post(BASE_URL, createPayload(name, jsData));
}

function updateCustomJS(id, name, jsData) {
  return _apiClient.default.put(BASE_URL + "/" + id, createPayload(name, jsData));
}

function validateCustomJS(jsData) {
  return _apiClient.default.post(BASE_URL + "/validate", {
    data: jsData,
    headers: {
      'content-type': 'text/plain'
    }
  });
}